export default "__VITE_ASSET__ovOWkTvX__"